module.exports = __webpack_public_path__ + "static/media/quiz-icon.aece401f.svg";


//////////////////
// WEBPACK FOOTER
// ./public/img/sidebar/quiz-icon.svg
// module id = 1033
// module chunks = 0